import { useMutation, useQuery, useQueryClient } from "react-query";
import { createEmployee, deleteEmployee, fetchEmployees, updateEmployee, } from "@/features/employee/services/employeeService";
const useEmployees = (page, filters, limit) => {
    const queryClient = useQueryClient();
    const queryKey = ["employees", { page, filters, limit }];
    const { data, error, isLoading, refetch } = useQuery(queryKey, () => fetchEmployees(page, filters, limit), {
        keepPreviousData: true,
        staleTime: 60000,
    });
    const createEmployeeMutation = useMutation((payload) => createEmployee(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries("employees");
        },
    });
    const updateEmployeeMutation = useMutation(({ id, payload }) => updateEmployee(id, payload), {
        onSuccess: () => {
            queryClient.invalidateQueries("employees");
        },
    });
    const deleteEmployeeMutation = useMutation((id) => deleteEmployee(id), {
        onSuccess: () => {
            queryClient.invalidateQueries("employees");
        },
    });
    return {
        employees: data?.items ?? [],
        meta: data?.meta ?? null,
        loading: isLoading,
        error: error?.message ?? null,
        refetchEmployees: refetch,
        handleCreateEmployee: createEmployeeMutation.mutateAsync,
        handleUpdateEmployee: (id, payload) => updateEmployeeMutation.mutateAsync({ id, payload }),
        handleDeleteEmployee: deleteEmployeeMutation.mutateAsync,
    };
};
export default useEmployees;
